export default __webpack_public_path__ + "static/media/movie-episode-4.01007516.jpg";